<script>
  import { onMount, onDestroy } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { getIdToken } from '../../../Api/api';
  import PulseStatusAnim from '../../Common/PulseStatusAnim.svelte';
  import VideoList from './VideoList.svelte';
  import { recordings } from './video-browser-store';
  import config from '../../../config';

  export let selectedRecordingKey = '';

  let fetchingData = false;
  let selectedRecording = null;
  let mql;
  let mediaMatchMinWidth640;
  let keyPrefix = 'streams/';

  onMount(async () => {
    if (!$recordings.length) {
      fetchingData = true;
      const res = await getRecordings();

      if (!res.error) {
        recordings.set(res.sort((a, b) => new Date(b.modified) - new Date(a.modified)));
      }
    }
    if (selectedRecordingKey) {
      const found = $recordings.filter((r) => r.key === keyPrefix + selectedRecordingKey);
      if (found.length) {
        selectedRecording = found[0];
      }
    }
    fetchingData = false;

    mql = window.matchMedia('(min-width: 640px)');
    mediaMatchMinWidth640 = mql.matches;
    mql.addEventListener('change', onScreenChange);
  });

  onDestroy(() => {
    mql.removeEventListener('change', onScreenChange);
  });

  const getRecordings = async () => {
    const token = await getIdToken();
    const params = {
      method: 'get',
      headers: { Authorization: `Bearer ${token}` },
    };
    const res = await fetch(`${config.baseUrl}/recordings`, params);
    return res.json();
  };

  const onScreenChange = (e) => {
    mediaMatchMinWidth640 = e.matches;
  };

  const fetchRecordings = async () => {
    fetchingData = true;
    const res = await getRecordings();
    recordings.set(res.sort((a, b) => new Date(b.modified) - new Date(a.modified)));
    fetchingData = false;
  };

  const onRecordingSelected = (e) => {
    selectedRecording = e.detail;
    const key = selectedRecording.key.replace(keyPrefix, '');
    navigate(`/chat/video/${key}`);
  };
</script>

<main>
  <header>
    {#if mediaMatchMinWidth640 || !selectedRecording}
      <button class="back-btn" on:click={() => navigate('/chat')}>
        <span class="material-icons"> west </span>
      </button>
    {/if}
    <div class="left-controls">
      {#if selectedRecording}
        <button class="close-video-btn" on:click={() => navigate('/chat/video')}>
          <span class="material-icons"> close </span>
        </button>
      {/if}
    </div>
  </header>
  <div class="container">
    {#if !mediaMatchMinWidth640}
      {#if !selectedRecording}
        <div class="sidebar">
          {#if !fetchingData}
            <VideoList
              recordings={$recordings}
              on:recordingselected={onRecordingSelected}
              on:refreshrecordings={fetchRecordings}
              {selectedRecording}
            />
          {:else}
            <div class="anim">
              <PulseStatusAnim />
            </div>
          {/if}
        </div>
      {:else}
        <div class="viewer">
          <video src={selectedRecording?.url} controls autoplay playsinline />
        </div>
      {/if}
    {:else}
      <div class="sidebar">
        {#if !fetchingData}
          <VideoList
            recordings={$recordings}
            on:recordingselected={onRecordingSelected}
            on:refreshrecordings={fetchRecordings}
            {selectedRecording}
          />
        {:else}
          <div class="anim">
            <PulseStatusAnim />
          </div>
        {/if}
      </div>
      <div class="viewer">
        <video src={selectedRecording?.url} controls autoplay playsinline />
      </div>
    {/if}
  </div>
</main>

<style src="./videoBrowser.scss"></style>
